import type {
  AdminPaginatedEnvelope,
  BusinessFee,
  BusinessFeeAction,
} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

export type FeeListProps<T> = {
  // Whatever the fetch threw, held only so a consumer could react to it
  // (none does today). `typeof Error` said "the Error constructor" rather
  // than "an Error", and the caught value is not required to be either.
  error: unknown;
  isLoading: boolean;
  isSearch?: boolean;
  isPageReset?: boolean;
  rawFeeCount: number;
  pageInfo: {
    total: number;
    page: number;
    summary?: AdminPaginatedEnvelope<T[]>['summary'];
  };
  list: T[];
  fetchList: (params: AfriexQueryParams) => void;
  /** Re-fetch the page the user is currently on (used after a create/update). */
  refetchCurrentPage: () => Promise<void>;
  /** 1-indexed page synced back to Pagination after a post-action re-fetch. */
  displayPage: number;
  setPage: (page: number) => void;
  filterCount: number;
  currentFilters: AfriexQueryParams;
  filtersToApply: AfriexQueryParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | Date | number | undefined,
  ) => void;
  handleApplyFilters: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (t: string) => void;
};

export enum FeeActionType {
  UPDATE_FEE = 'UPDATE_FEE',
  ADD_TAG = 'ADD_TAG',
  REMOVE_TAG = 'REMOVE_TAG',
  ADD_ACTION_TO_FEE = 'ADD_ACTION_TO_FEE',
  REMOVE_ACTION_FROM_FEE = 'REMOVE_ACTION_FROM_FEE',
}

export interface UpdateFeeAction {
  type:
    | FeeActionType.UPDATE_FEE
    | FeeActionType.ADD_TAG
    | FeeActionType.REMOVE_TAG
    | FeeActionType.ADD_ACTION_TO_FEE
    | FeeActionType.REMOVE_ACTION_FROM_FEE;

  payload: Partial<BusinessFee> | string | BusinessFeeAction;
}

export type FeeAction = UpdateFeeAction;
